module.exports = __webpack_public_path__ + "img/payment-timeout-illustration.00db7bea.svg";